import _ from 'lodash'

export const getProfile = (state) => _.get(state, 'profile.profile')

export const getRecentRewards = (state) => _.get(state, 'profile.recentRewards')

export const getPreferredTopics = (state) =>
  _.get(state, 'profile.preferredTopics')
